// The chart panels' rendered titles, published by charts-row for the PDF.
//
// A panel's title is data-driven (DEV-2432 §1: "(Top 10)" appears only when the
// breakdown had to cut a variable), so the PDF builder — which reads the layout
// config alone — cannot derive it. charts-row writes the live titles here on
// every render; download-report hands them to buildReportData, and the render
// route primes the same ref from its frozen snapshot. Same pattern as
// card-snapshot / gridPdfSnapshot.
export const chartTitlesSnapshot: { current: Record<string, string> } = {
	current: {}
}
